/**
 * @generated SignedSource<<a31437d6a6fe517edd64d5dd64d2e4ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetRequestSummaryEstimation_Booking$data = {
  readonly startSlot: {
    readonly slotRates?: ReadonlyArray<{
      readonly eighteenHolePrice: number | null | undefined;
      readonly nineHolePrice: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetRequestSummaryEstimation_Booking";
};
export type useGetRequestSummaryEstimation_Booking$key = {
  readonly " $data"?: useGetRequestSummaryEstimation_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetRequestSummaryEstimation_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetRequestSummaryEstimation_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "slotRates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "highestPrecedentOnly",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "CUSTOMER"
                }
              ],
              "concreteType": "SlotRate",
              "kind": "LinkedField",
              "name": "playerRates",
              "plural": true,
              "selections": [
                {
                  "alias": "nineHolePrice",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "holeCount",
                      "value": "NINE"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalGolfPrice",
                  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
                },
                {
                  "alias": "eighteenHolePrice",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "holeCount",
                      "value": "EIGHTEEN"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalGolfPrice",
                  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
                }
              ],
              "storageKey": "playerRates(highestPrecedentOnly:true,type:\"CUSTOMER\")"
            }
          ],
          "type": "QueueSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "5ee68d2005e1639afbccbba14e9fc1dc";

export default node;
